import { render, staticRenderFns } from "./vcSelectWorkerLogistics.vue?vue&type=template&id=02335495&"
import script from "./vcSelectWorkerLogistics.vue?vue&type=script&lang=js&"
export * from "./vcSelectWorkerLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports